import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  Icon,
  Modal,
  Pagination,
  Table,
  TableHeader,
  Text,
} from '@fairfashion/design-system'

import { ProviderRisks } from '../../../../components/ProviderRisks/provider-risks.comp'
import { ICompanyProvidersResponseDTO } from '../../../../sdk/company/company.types'
import { ProviderDashboardContext } from '../../provider-dashboard.context'

import * as Styles from './providers-risks-card.styles'
import { risksData, risksHeaders } from './providers-risks-card.utils'

export const ProvidersRisksCard = () => {
  const [page, setPage] = useState(1)
  const [selected, setSelected] = useState<ICompanyProvidersResponseDTO>()

  const { providersWithRisks, providersWithRisksCount, actions } = useContext(
    ProviderDashboardContext,
  )

  useEffect(() => {
    actions.fetchProvidersWithRisks(page)
  }, [page])

  const providersRisksHeaders: TableHeader[] = [
    { key: 'name', label: 'Fornecedor', minWidth: '200px' },
    {
      key: 'status',
      label: 'Status',
      width: '60px',
      align: 'center',
      customRender: (row) => (
        <Box justifyContent="center" width="100%">
          <Styles.Badge active={row.status}>
            {row.status === 'active' ? 'Ativo' : 'Inativo'}
          </Styles.Badge>
        </Box>
      ),
    },
    {
      key: 'risk',
      label: 'Riscos',
      align: 'center',
      width: '50px',
      customRender: (row) => (
        <Box justifyContent="center" gap={1} width="100%" alignItems="center">
          <Icon color="warning" name="flag" size={20} />
          <Styles.CircleBackground>
            {row?.socialEnvironmentalRisks?.length ?? 0}
          </Styles.CircleBackground>
        </Box>
      ),
    },
    {
      key: 'details',
      label: 'Detalhes',
      align: 'center',
      width: '50px',
      customRender: (row) => (
        <Box justifyContent="center" width="100%">
          <Button variant="text" padding="0" onClick={() => setSelected(row)}>
            <Icon name="file_search" size={20} color="secondary" />
          </Button>
        </Box>
      ),
    },
  ]

  return (
    <Styles.Card>
      <Box gap={2} alignItems="center" width="100%">
        <Styles.IconContainer>
          <Icon name="flag" color="warning" size={24} />
        </Styles.IconContainer>
        <Text fontWeight={500}>Riscos Socioambientais</Text>
      </Box>

      <Box direction="column" gap={1} width="100%">
        <Styles.BigNumber>{providersWithRisksCount}</Styles.BigNumber>
        <Text color="grey_3" size="small">
          Fornecedores
        </Text>
      </Box>

      <Box height="1px" width="100%" backgroundColor="grey_5" />

      <Box width="100%" direction="column" gap={2}>
        <Text size="small" fontWeight={500}>
          Detalhes dos riscos
        </Text>
        {providersWithRisks?.length === 0 ? (
          <Table headers={risksHeaders} data={risksData} spacing="small" />
        ) : (
          <Table
            headers={providersRisksHeaders}
            data={providersWithRisks}
            spacing="small"
            footer={
              <Box width="100%" justifyContent="center" padding={1}>
                <Pagination
                  total={Math.ceil(providersWithRisksCount / 5)}
                  onChange={(_page) => setPage(_page)}
                />
              </Box>
            }
          />
        )}
      </Box>

      <Modal
        open={!!selected}
        onClose={() => setSelected(undefined)}
        width="800px"
        maxWidth="90%"
        title="Riscos socioambientais"
      >
        <Box padding={2} width="90%">
          <ProviderRisks
            socialEnvironmentalRisk={selected?.socialEnvironmentalRisks}
          />
        </Box>
      </Modal>
    </Styles.Card>
  )
}
